<template>
    <div class="v-crud-category-multi-select">
        <el-select
            :value="value ? value.split(',').map(Number) : []"
            @input="updateValue"
            placeholder="Please select a category"
            :loading="loading"
            multiple
        >
            <el-option
                v-for="item in remoteValues"
                :key="item.id"
                :label="item.name"
                :value="item.id"
            >
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    data() {
        return {
            remoteValues: [],
            loading: false,
            categoryID: null,
        };
    },
    name: 'v-crud-category-multi-select',
    props: ['options', 'placeholder', 'value', 'rootConfig'],
    methods: {
        updateValue(v) {
            this.$emit('input', v.toString());
        },
        getSortedCategories() {
            this.loading = true;
            this.api
                .get({ per_page: 1000 })
                .then((res) => {
                    if (res.data) {
                        this.remoteValues = res.data;
                        this.remoteValues = this.recursiveCategory(-1, [], 0);
                        this.loading = false;
                    }
                })
                .catch((res) => {
                    this.loading = false;
                    console.error(res);
                    this.$message('Something went wrong. Please try again.');
                });
        },
        recursiveCategory(i, data, parentId) {
            const childData = this.remoteValues.filter(
                (e) => e.parent_id === parentId
            );
            if (childData) {
                i++;
                childData.forEach((e) => {
                    if (i > 0) {
                        let element = ['', '→', '»', '◦'];
                        e.name =
                            Array(4 * i)
                                .fill('\xa0')
                                .join('') +
                            (element[i] || '→') +
                            ' ' +
                            e.name;
                    }
                    data.push(e);
                    data = this.recursiveCategory(i, data, e.id);
                });
            }
            return data;
        },
    },
    mounted() {
        this.getSortedCategories();
    },
    computed: {
        api() {
            return this.$resource(
                [this.rootConfig.endPoint, 'categories', this.categoryID].join(
                    '/'
                ),
                {},
                {},
                { headers: this.rootConfig.headers }
            );
        },
    },
};
</script>

<style scoped>
.v-crud-category-multi-select .el-select {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// CategoryMultiSelect.vue?a59d892c